export default __webpack_public_path__ + "static/media/hp-ai-img.8f4a349e.svg";